import { useMutation } from "@tanstack/react-query";
import smsTemplateService from "..";

function useCreateTemplate() {
  return useMutation({
    mutationFn: smsTemplateService.createCustomTemplate,
  });
}

export default useCreateTemplate;
